var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#005068"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.668 7.33317C12.668 6.96498 12.3695 6.6665 12.0013 6.6665C11.6331 6.6665 11.3346 6.96498 11.3346 7.33317V11.3332H7.33464C6.96645 11.3332 6.66797 11.6316 6.66797 11.9998C6.66797 12.368 6.96645 12.6665 7.33464 12.6665H11.3346V16.6665C11.3346 17.0347 11.6331 17.3332 12.0013 17.3332C12.3695 17.3332 12.668 17.0347 12.668 16.6665V12.6665H16.668C17.0362 12.6665 17.3346 12.368 17.3346 11.9998C17.3346 11.6316 17.0362 11.3332 16.668 11.3332H12.668V7.33317Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCta);
export default __webpack_public_path__ + "static/media/CTA.12bfd9b0eb71249a865280c04100c423.svg";
export { ForwardRef as ReactComponent };